<template>
  <myhead @next="next">
    {{ $route.query.title || $route.meta.title }}
  </myhead>
  <!-- 日期标题 -->
  <div class="tracenav">
    <div class="date-box">
      <div class="item" v-for="(item, index) in weekList" :class="{ active: currentIndex === index ,gray: item.isDisabled }" @click="activeDate(item)"
        :key="index">
        {{ item.week }}
      </div>
    </div>
  </div>
  <!-- 展示列表 -->
  <div class="tracelist" id="tracelist">
    <template v-for="(item,name,index) in showList" :key="index">
      <p class="tracelist-day size14">{{ name }}</p>
      <ul class="flex traceul">
        <li v-for="(v,index) in item" :key="index" @click="goDetail(v)">
          <div class="relative">
              <div class="absolute l t size16  pad2" :class="v.sales_method == 1 ? 'BGshop1' : v.sales_method == 2 ? 'BGshop2' : 'BGshop3' ">{{ v.sales_name }}</div>
              <img :src="v.original_img">
           </div>
          <div class="mt12 mb12">
            <p class="size14">{{v.goods_name}}</p>
            <p v-if="v.sales_method == 1" class="tracelist-price size17"><span class="size14">¥</span>{{ v.shop_price}}</p>
            <p v-if="v.sales_method == 2" class="tracelist-price size16" @click.stop="handleZX(v)">报价咨询</p>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>
<script setup>
import ajax from "@/utils/request.js";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";


const { push } = useRouter()
const router =  useRouter()
// 列表总数据
const infoList = ref([])
// 展示数据
const showList = ref([])

// head事件
const next = () => {
  if (history.forward) {
    history.forward()
  }
}
//跳转详情页
const goDetail = (item) => {
  push({ path: '/shop/detail', query: { goods_id: item.goods_id } })
}
// dsq add 咨询
const handleZX = (item) => {
  router.push({ path: '/shop/feedback', query: { title: '咨询定制商品', goods_id: item.goods_id, type: 2 } })
}

// 获取列表数据
const traceItem = async () => {
  await dateInit()
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const date = year + '-' + month + '-' + day
  return ajax.post("products/getbrowselists", { time: date }).then(res => {
    infoList.value = res.data
    let list = []
    let grayList = []
    res.data.forEach(item => {
      let val = item['time']
      if (val in list) {
        list[val].push(item)
      } else {
        list[val] = []
        list[val].push(item)
        grayList.push(val)
      }
      showList.value = { ...list }
      weekList.value.forEach(item => {
        if (grayList.includes(item.dateValue)) {
          item.isDisabled = false
        } else {
          item.isDisabled = true

        }
      })
    })
  })
}

// 选中时间
const currentIndex = ref(6); // Current selected index
// 日期数组
const weekList = ref([]);
//初始化时间
const dateInit = () => {
  for (let i = 6; i >= 0; i--) {
    const today = new Date();
    today.setDate(today.getDate() - i);
    format(today);
  }
};
// 时间格式处理
const format = (today) => {
  const currentDay = new Date();
  const diff = currentDay.getTime() - today.getTime();
  const diffDays = Math.floor(diff / (1000 * 3600 * 24));
  let week = '';
  const day =
    parseInt(today.getDate()) > 9 ? today.getDate() : '0' + today.getDate();
  const month =
    parseInt(today.getMonth()) + 1 > 9
      ? today.getMonth() + 1
      : '0' + (today.getMonth() + 1);
  const year = today.getFullYear();

  if (diffDays === 0) {
    week = '当天';
  } else if (diffDays === 1) {
    week = '昨天';
  } else if (diffDays === 2) {
    week = '前天';
  } else {
    week = '周' + ['日', '一', '二', '三', '四', '五', '六'][today.getDay()];
  }

  const obj = {
    id: weekList.value.length + 1,
    week,
    dateValue: month + '月' + day + '日',
    date: year + '-' + month + '-' + day,
  };

  weekList.value.push(obj);
};
// 切换选中状态
const activeDate = (val) => {
  currentIndex.value = val.id - 1
  let l = infoList.value.filter(item => item.time == val.dateValue)
  let list = []

  l.forEach(item => {
    let val = item['time']
    if (val in list) {
      list[val].push(item)
    } else {
      list[val] = []
      list[val].push(item)
    }
    showList.value = { ...list }

  })
}
// 获取当前时间
onMounted(() => {

  traceItem()
})


</script>
<style scoped lang="scss">
.tracenav{
  position: fixed;
  top: 40px;
  width: 100vw;
  background-color: #fff;
  z-index: 999;
  .date-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 50px;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #eee;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;

      &.active {
        color: #3f7b91;
      }
      &.gray{
        color: gray;
        pointer-events: none; 
      }
    }
  }
}
.tracelist{
  padding-top: 60px;
}
.tracelist-day {
  padding-left: 4.2667vw;
}
.traceul {
  padding: 3.2vw 4vw 0;
  margin-bottom: 8vw;
  justify-content: flex-start;
  li {
    margin-right: 2.5vw;
    &:nth-child(3n) {
      margin-right: 0;
    }
    img {
      display: block;
      width: 28.8vw;
      height: 28.8vw;
      background-color: #f6f6f6;
    }
    p {
      width: 18.9333vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tracelist-price {
      color: #FF0000;
    }
  }
}
</style>
<style lang="scss">

.tracelist-day {
  padding-left: 4.2667vw;
}
.traceul {
  padding: 3.2vw 4vw 0;
  margin-bottom: 8vw;
  justify-content: flex-start;
  li {
    &:nth-child(3) {
      margin-right: 0;
    }
    img {
      display: block;
      width: 28.8vw;
      height: 28.8vw;
      background-color: #f6f6f6;
    }
    p {
      width: 18.9333vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tracelist-price {
      color: #FF0000;
    }
  }
}
</style>